module.exports = __webpack_public_path__ + "img/B-title-02-mobile.9809972b.png";